export const shoppingListRegexp = new RegExp(/(https:\/\/mojagazetka.com\/lista\/)(\w+)/)
export const uuidRegExp = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/)

export const releaseNotesUrl = 'https://docs.google.com/document/d/18zgBrxW6MHkrCMXPi9OBI27zTSemxH460IDSS5iiwBM'
// https://www.freecodecamp.org/news/how-to-write-a-regular-expression-for-a-url/
export const urlRegExp = new RegExp(
  /^(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/
)

export const APPLICATION_CHANNELS = [
  'NEW_OFFERS_NOTIFICATION',
  'NEW_OFFERS_NOTIFICATION_WITH_CUSTOM_TEXT',
  'NEW_OFFERS_NOTIFICATION_EXTENDED',
  'PROMOTIONAL_NOTIFICATION_EXTENDED'
] as const

// roles order IS IMPORTANT, sorted by the most significant
export const APPLICATION_AVAILABLE_USER_ROLES = [
  'ROOT',
  'ADMIN',
  'EDITOR',
  'EDITOR_REELS',
  'EDITOR_RECIPE',
  'EDITOR_NOTIFICATION'
]

export const APPLICATION_STARTPOINT = {
  ROOT: '/dashboard',
  ADMIN: '/dashboard',
  EDITOR: '/dashboard',
  EDITOR_NOTIFICATION: '/selective-notifications',
  EDITOR_RECIPE: '/recipes',
  EDITOR_REELS: '/reels'
}

export const APPLICATION_WHITE_LIST = ['/login'] // no redirect whitelist

export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy'
export const DEFAULT_DATETIME_FORMAT = 'dd.MM.yyyy HH:mm'
export const COLLAPSED_ELEMENTS_CLEANUP_TIME = 3500

export const TABLET_WIDTH = 768
